import { FC, MouseEventHandler } from 'react';

import { Badge, VisuallyHidden } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HTMLContent from '@telialt/common-html-content/src';
import { useComponentId } from '@telialt/utils/src/hooks';

import { CategoryWrapper, ContentCardWrapper, DescriptionWrapper, StyledBadge, StyledLink } from './ContentCard.styles';

type Props = {
    title: string;
    description?: string;
    url: string;
    categoryLevel1?: string;
    categoryLevel2?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const ContentCard: FC<Props> = ({ title, description, url, categoryLevel1, categoryLevel2, onClick }) => {
    const { t } = useTranslations();
    const cardId = useComponentId();

    return (
        <ContentCardWrapper aria-labelledby={cardId}>
            <CategoryWrapper>
                {(categoryLevel1 || categoryLevel2) && (
                    <VisuallyHidden>{t['search.results.content_categories']} </VisuallyHidden>
                )}
                {categoryLevel1 && (
                    <StyledBadge showIcon={false} variant="neutral">
                        {categoryLevel1}
                    </StyledBadge>
                )}
                {categoryLevel2 && (
                    <Badge showIcon={false} variant="information">
                        {categoryLevel2}
                    </Badge>
                )}
            </CategoryWrapper>
            <div>
                <StyledLink href={url} onClick={onClick} id={cardId}>
                    {title}
                </StyledLink>
            </div>
            {description && (
                <DescriptionWrapper aria-hidden="true">
                    <HTMLContent content={description} />
                </DescriptionWrapper>
            )}
        </ContentCardWrapper>
    );
};
